export default "__VITE_ASSET__DurzVsi9__"